<template>
  <div class="reply">
    <div v-for='(item,index) in replyArr' class="replyItem" :key="index">
      <div class="title f20 line28">
        在
        <router-link :to="{name:'echoInfo',params:{id:item.did}}" class="ftheme mainTitle fw600">{{item.title}}</router-link>
        中评论：
      </div>
      <div class="felx_r f16 fgray">
        <span class="">{{item.time}}</span>
        <svgIcon class="marginl20" name="delete" />
        <span @click="del(index,item.id)" class="marginl4 cursor">删除</span>
      </div>
      <div class="margint20 f20 line36 limit2">{{item.content}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "replyGroup",
  props: {
    replyArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods:{
    async del(index,id){
      this.$alert('确定删除吗？',{
        showClose: true,
        showCancelButton: true,
        callback: async(action,instance)=>{
          if(action=='confirm'){
            let data = await this.$http.get(this.$api.delReply,{params:{id}});
            this.$message.success(data.msg);
            this.$emit('del',index)
          }
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.replyItem {
  padding: 44px 0 40px;
}
.mainTitle{
  text-decoration: underline;
}
</style>